import { Create, SimpleForm, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';

const initialValues = {
  token: '',
};
export const DeviceCreate = (props: unknown) => (
  <Create {...props} title={<CustomTitle />}>
    <SimpleForm redirect={false} defaultValues={initialValues}>
      <TextInput source="token" />
    </SimpleForm>
  </Create>
);
